import { catchAllRoutes } from "@/routes/constants.mjs";
import type { BaseRoute } from "@/routes/routes.mjs";
import appRouteArticles from "@/util/app-route-articles.mjs";
import lazyFn from "@/util/lazy-fn.mjs";
import pathRegExp from "@/util/path-regexp.mjs";

const apexFetchMatchData = lazyFn(
  () => import("@/game-apex/apex-fetch-match-data.mjs"),
);
const apexFetchProfileData = lazyFn(
  () => import("@/game-apex/fetches/profile-page.mjs"),
);

const routes: BaseRoute[] = [
  {
    path: pathRegExp("/apex/profile/:profileId{/:tab}?"),
    component: "game-apex/Profile.jsx",
    fetchData: apexFetchProfileData,
  },
  {
    path: pathRegExp("/apex/match/:profileId/:seasonId/:matchId"),
    component: "game-apex/Match.jsx",
    fetchData: apexFetchMatchData,
  },
  ...appRouteArticles("apex"),
];

routes.push({
  [catchAllRoutes]: routes,
  async fetchData() {
    const { getLegends, getSeasons, getWeapons } = await import(
      "@/game-apex/apex-fetch-static.mjs"
    );
    return Promise.all([getSeasons(), getWeapons(), getLegends()]);
  },
});

export default routes;
